import React, { useEffect, useState, useContext } from "react";
import { NavLink } from "react-router-dom";
import CreditTab from "../CreditTab";
import * as services from "../../../store/service";
import { useSelector, useDispatch } from "react-redux";
import { ApplicationState } from "../../../store";
import { IBusinessProfileResponse } from "../../../store/businessProfileService/types";
import * as BusinessProfileActions from "../../../store/businessProfileService/actions";
import * as LoginActions from "../../../store/loginService/actions";
import * as ConfigurationActions from "../../../store/configurationService/actions";
import { CommonContext } from "../../../CommonContextProvider";
import * as BusinessCreditReportAction from "../../../store/businessCreditReportService/actions";

interface ICompanyInformation {
    CompanyId: string;
    Name: string;
    Address: string;
    City: string;
    State: string;
    Zip: string;
    PhoneNumber: string;
    CreditSafeNumber: string;
    DUNSNumber: string;
    CreditProvider: string;
    Detail: string;
}

const GetStarted = (props: any) => {
    const query = new URLSearchParams(props.location.search);
    const dispatch = useDispatch();
    let companyInfo: ICompanyInformation = {} as ICompanyInformation;
    const [selectedBusinessProfile, setSelectedBusinessProfile] = useState(companyInfo);
    const [selectedTab, setSelectedTab] = useState("0");
    const businessProfileStatus = useSelector(
        (state: ApplicationState) =>
            state.loggedInUser &&
            state.loggedInUser.userServiceDetails?.businessProfileStatus?.filter((obj: any) => {
                return obj.provider;
            })
    );
    const [loading, setLoading] = useState(false);
    const { updateBusinessProfileDshboardGetStartedStatus }: any = useContext(CommonContext);
    const requestBusinessCreditReport = (ReportPK: any, forcefullyRefresh: boolean, creditProvider: string) =>
        dispatch(BusinessCreditReportAction.actionCreators.requestBusinessCreditReport(ReportPK, forcefullyRefresh, creditProvider));
    const updateSmbServiceDetails = () => dispatch(LoginActions.actionCreators.updateSmbServiceDetails());
    const requestBusinessProfile = (profile?: IBusinessProfileResponse) => dispatch(BusinessProfileActions.actionCreators.requestBusinessProfile(profile));
    const businessProfileSelector = useSelector((state: ApplicationState) => state.businessProfileState && state.businessProfileState.businessProfileData);
    const routeLoading = useSelector((state: ApplicationState) => state.configurationState && (state.configurationState.loading || false));

    const RegisterCompany = () => {
        let requestBody = {
            BusinessInfoList: [
                {
                    CompanyId: selectedBusinessProfile.CompanyId,
                    Name: selectedBusinessProfile.Name,
                    Address: selectedBusinessProfile.Address,
                    City: selectedBusinessProfile.City,
                    State: selectedBusinessProfile.State,
                    Zip: selectedBusinessProfile.Zip,
                    PhoneNumber: selectedBusinessProfile.PhoneNumber,
                    CreditSafeNumber: "",
                    DUNSNumber: "",
                    CreditProvider: selectedBusinessProfile.CreditProvider,
                },
            ],
        };

        setLoading(true);
        services.RegisterBusinessForCreditMonitoring(requestBody).then((data: any) => {
            updateBusinessProfileDshboardGetStartedStatus();
            updateSmbServiceDetails();
            services
                .getNewBusinessCreditReport(null, selectedBusinessProfile.CreditProvider)
                .then((data) => {
                    requestBusinessCreditReport(null, true, selectedBusinessProfile.CreditProvider);
                    setLoading(false);
                })
                .catch(function (error) {
                    setLoading(false);
                })
                .finally(function () {
                    if (selectedTab === "0") {
                        props.history.push("/dashboard");
                    } else if (selectedTab === "1") {
                        props.history.push("/credit/score");
                    } else if (selectedTab === "2") {
                        props.history.push("/credit/report");
                    }
                });
        });
    };

    const ensureDataFetched = () => {
        const tmpselectedTab = query.get("selectedTab");
        if (tmpselectedTab != null) {
            setSelectedTab(tmpselectedTab);
        }
        if (businessProfileSelector != null) {
            setSelectedBusinessProfile(businessProfileSelector);
            requestBusinessProfile();
        } else {
            setLoading(true);
            services.getSmbContactInfo().then((data: any) => {
                if (data) {
                    const creditProvider = businessProfileStatus != null && businessProfileStatus.length > 0 ? businessProfileStatus[0].provider : "";
                    const searchQuery = {
                        SearchLimit: "10",
                        Name: data.businessName,
                        Address: data.address1,
                        City: data.city,
                        State: data.state,
                        Zip: data.zipCode,
                        PhoneNumber: data.phone,
                        CreditProvider: creditProvider,
                    };
                    services.SearchCompany(searchQuery).then((companyInformationArray: any) => {
                        if (companyInformationArray?.Companies?.length > 0) {
                            const companyInformation: any = companyInformationArray.Companies[0];
                            companyInfo.Address = companyInformation.Address;
                            companyInfo.City = companyInformation.City;
                            companyInfo.CompanyId = companyInformation.Id;
                            companyInfo.Detail = companyInformation.Details;
                            companyInfo.Name = companyInformation.Name;
                            companyInfo.PhoneNumber = companyInformation.PhoneNumber;
                            companyInfo.State = companyInformation.State;
                            companyInfo.Zip = companyInformation.Zip;
                            companyInfo.CreditProvider = creditProvider;
                            setSelectedBusinessProfile(companyInfo);
                        } else {
                            props.history.push("/bcredit/search?selectedTab=" + selectedTab);
                        }
                        setLoading(false);
                    });
                }
            });
        }
    };

    useEffect(() => {
        ensureDataFetched();
    }, []);

    useEffect(() => {
        if (routeLoading) {
            dispatch(ConfigurationActions.actionCreators.setRouteLoading(false));
        }
    }, [dispatch, routeLoading]);

    return (
        <React.Fragment>
            <div className=" row between-xs middle-xs">
                <div className="col-xs">
                    <h1 className="title-page" id="title-page" tabIndex={-1}>
                        Credit
                    </h1>
                </div>
                <div className="col-xs flex-grow-null">
                    {selectedTab === "0" && (
                        <button
                            type="button"
                            className="btn-default btn-primary-outline btn-no-border btn-no-padding btn-icon-only"
                            onClick={() => props.history.push("/dashboard")}
                        >
                            <span className="btn-icon">
                                <em className="las la-times"></em>
                            </span>
                            <span className="btn-text">Cancel</span>
                        </button>
                    )}
                </div>
            </div>

            {selectedTab !== "0" && <CreditTab selectedTab={selectedTab} />}

            <div className="row" id="content">
                <div className="col-xs-12">
                    <div className="box offset-padding">
                        <div className="box-header">
                            <div className="box-title-container">
                                <div className="box-title-icon" aria-hidden="true">
                                    <em className="las la-search"></em>
                                </div>
                                <div className="box-title-text has-actions">
                                    <h2 className="box-title">Find your Business Credit Profile</h2>
                                </div>
                            </div>
                            <div className="box-description">
                                <p>
                                    Please confirm your business, listed below. If your business is listed with an outdated address, please select "Yes" - you will
                                    be able to update your company details later.
                                </p>
                            </div>
                        </div>

                        <div className={loading ? "box-content loading" : "box-content"}>
                            <form id="form-add-employee-single">
                                <div className="property-details">
                                    <div className="property-icon">
                                        <em className="las la-building"></em>
                                    </div>
                                    <div className="property-address">
                                        <p>
                                            <strong>{selectedBusinessProfile.Name}</strong> {selectedBusinessProfile.Detail}
                                        </p>
                                    </div>
                                </div>

                                <div className="margin-top-xl"></div>

                                <div className="row between-sm">
                                    <div className="col-xs-12 col-sm col-no-gutter margin-bottom-s flex-grow-null">
                                        {selectedTab === "0" ? (
                                            <NavLink to="/bcredit/search" className="btn-default btn-primary-outline">
                                                <span className="btn-text">No, this is not my business</span>
                                            </NavLink>
                                        ) : (
                                            <NavLink to={"/bcredit/search?selectedTab=" + selectedTab} className="btn-default btn-primary-outline">
                                                <span className="btn-text">No, this is not my business</span>
                                            </NavLink>
                                        )}
                                    </div>
                                    <div className="col-xs-12 col-sm col-no-gutter flex-grow-null">
                                        <button type="button" className="btn-default btn-primary btn-min-width" onClick={() => RegisterCompany()}>
                                            <span className="btn-text">Yes, this is my business</span>
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default GetStarted;
